import { useCallback, useRef, useState } from "react";
import toast from "react-hot-toast";

export const isFileDrag = (e) =>
  Array.from(e.dataTransfer?.types || []).includes("Files");

export const useFileDrop = ({
  onFile,
  onFiles,
  accept = "video/",
  disabled = false,
}) => {
  const [isDragActive, setIsDragActive] = useState(false);
  const dragCounter = useRef(0);

  const handleDragEnter = useCallback(
    (e) => {
      if (disabled || !isFileDrag(e)) return;
      e.preventDefault();
      e.stopPropagation();
      dragCounter.current += 1;
      setIsDragActive(true);
    },
    [disabled]
  );

  const handleDragLeave = useCallback(
    (e) => {
      if (disabled || !isFileDrag(e)) return;
      e.preventDefault();
      e.stopPropagation();
      dragCounter.current = Math.max(0, dragCounter.current - 1);
      if (dragCounter.current === 0) setIsDragActive(false);
    },
    [disabled]
  );

  const handleDragOver = useCallback(
    (e) => {
      if (disabled || !isFileDrag(e)) return;
      e.preventDefault();
      e.stopPropagation();
      e.dataTransfer.dropEffect = "copy";
    },
    [disabled]
  );

  const handleDrop = useCallback(
    (e) => {
      if (!isFileDrag(e)) return;
      e.preventDefault();
      e.stopPropagation();
      dragCounter.current = 0;
      setIsDragActive(false);
      if (disabled) return;

      const files = Array.from(e.dataTransfer.files || []);
      const matching = files.filter((f) => f.type.startsWith(accept));
      if (!matching.length) {
        if (files.length) toast.error("Можно загрузить только видеофайлы");
        return;
      }
      if (onFiles) onFiles(matching);
      if (onFile) onFile(matching[0]);
    },
    [onFile, onFiles, accept, disabled]
  );

  return {
    isDragActive,
    dropHandlers: {
      onDragEnter: handleDragEnter,
      onDragLeave: handleDragLeave,
      onDragOver: handleDragOver,
      onDrop: handleDrop,
    },
  };
};
